import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MatDividerModule } from "@angular/material/divider";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { AlertModule, ButtonModule } from "@jack-sparrow-libraries/ui-kit";
import { AlertAyWebComponent } from "@shared-ay/alert-ay-web/alert-ay-web.component";

@NgModule({
	declarations: [AlertAyWebComponent],
	imports: [CommonModule, MatDividerModule, MatDialogModule, MatIconModule, ButtonModule, AlertModule],
	exports: [AlertAyWebComponent],
})
export class AlertAyWebModule {}
